var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-main"},_vm._l((_vm.infos),function(info,index){return (_vm.utils.string.vNotEmpty(info.value))?_c('div',{key:index,staticClass:"info-item"},[_c('div',{staticStyle:{"color":"#989898"}},[_vm._v(_vm._s(info.label))]),_c('div',[_vm._v(_vm._s(info.value))])]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }